export default class PageContext {
  pageName: string;
  pageCode: string;
  subPageCode?: string;
  requireLogin: boolean = false;
  requireCurrentOrg: boolean = false;
  pageAttributeKey?: string;
  componentResolver?: any;
  eventBus?: any;
}
